
import { useReduxAuth } from "../contexts/ReduxAuthContext";

export const useAuth = useReduxAuth;

export default useAuth;

